module.exports = __webpack_public_path__ + "static/media/phone.7385cd66.svg";